import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { BankLog, Setting } from "lib/models";
import toast from "react-hot-toast";
import { apiGet } from "components/Common/Axios";
import { Dialog, DialogContent } from "components/ui/dialog";
import BankLogList, { ListType } from "./BankLogList";

export type IssuedType = "new" | "total" | "lecture" | "material";

const BankLogPopup = ({
  open,
  onOpenChange,
  setting,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  setting: Setting;
}) => {
  const [bankLogs, setBankLogs] = useState<BankLog[]>([]);

  const loadBankLogs = async () => {
    const response = await apiGet("/bank/log");
    if (response.error) {
      toast.error("통장 내역을 불러오는데 실패했습니다.");
      console.error("loadBankLogs error", response.error);
      return;
    }

    setBankLogs(response.data);
  };

  useEffect(() => {
    if (open) {
      loadBankLogs();
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-1rem)] max-w-[calc(100%-1rem)] md:max-w-screen-xl min-h-[50%] max-h-[80%] overflow-x-hidden overflow-y-auto thin-scrollbar pb-0">
        <Card className="border-0 shadow-none">
          <CardHeader className="px-0 pt-0 pb-3 mb-1 sm:px-2 border-b border-gray-100">
            <CardTitle className="text-xl sm:text-2xl font-bold text-center text-gray-900">
              통장 내역
            </CardTitle>
          </CardHeader>
          <CardContent className="px-0 sm:px-2 flex flex-col gap-3 text-sm">
            <BankLogList
              bankLogs={bankLogs}
              setBankLogs={setBankLogs}
              listType={ListType.search}
              onOpenChange={onOpenChange}
              setting={setting}
            />
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default BankLogPopup;
